module.exports = __webpack_public_path__ + "img/login_1.6eec2807.png";